module.exports = __webpack_public_path__ + "static/00045.78cb03ae.jpg";